import { boolean, object, string } from "yup";

const defaultMessage = "To pole jest wymagane";

export const validationSchema = object().shape({
  email: string()
    .required(defaultMessage)
    .email("Proszę wpisać poprany adres email (np: jankowalski@domena.com)"),
  firstName: string().required(defaultMessage),
  privacyDealer: boolean().oneOf([true], defaultMessage),
  lastName: string().required(defaultMessage),
  company: string().required(defaultMessage),
  message: string().required(defaultMessage),
  vat: string().required(defaultMessage),
  billingAddress1: string().required(defaultMessage),
  billingAddress2: string(),
  billingAddressCity: string().required(defaultMessage),
  billingAddressZip: string().required(defaultMessage),
  billingAddressCountry: string().required(defaultMessage),
  deliveryAddress1: string().when("isDeliveryDifferent", {
    is: true,
    then: string().required(defaultMessage),
  }),
  deliveryAddress2: string(),
  deliveryAddressCity: string().when("isDeliveryDifferent", {
    is: true,
    then: string().required(defaultMessage),
  }),
  deliveryAddressZip: string().when("isDeliveryDifferent", {
    is: true,
    then: string().required(defaultMessage),
  }),
  deliveryAddressCountry: string().when("isDeliveryDifferent", {
    is: true,
    then: string().required(defaultMessage),
  }),
  isDeliveryDifferent: boolean(),
});
